
export class OrderDetail {

  public orderDetailID: number;
  public orderID: number;
  public productID: number;
  public brandID: number;
  public categoryID: number;
  public vendorID: number;
  public price: number;
  public salePrice: number;
  public quantity: number;
  public priceEach: number;
  public tax: number;
  public weightEach: number;
  public weight: number;
  public imageUrl: string;
  public isCustomerVisible: boolean;
  public purchaseOrderStatusID: number;
  public referenceOrderDetailID: number;
  public commissionType : number;
  public commissionPrices : number;
  public couponID: number;

  public productPath: string;
  public productName: string;
  public productBrandName: string;
  public productVendorName: string;
  public isNewProduct: boolean = false;
  public totalRecords: number;
  public productArrtibuteFields: string;
  public productArrtibuteValue: string;

}



// WEBPACK FOOTER //
// ./src/app/models/order/order-detail.model.ts